import type {
  IPasswordResetVerifyDto,
  IPasswordResetVerifyResponse,
} from "./types";
import type { IPathBaseParam } from "./path";

import type { IApiResponse } from "@/api";
import { createPostApi } from "@api/util/createPostApi";

const postApis = createPostApi<
  IApiResponse<IPasswordResetVerifyResponse>,
  IPathBaseParam,
  IPasswordResetVerifyDto
>("auth.passwordReset.verify");

export const verify = {
  ...postApis,
};
